module.exports = __webpack_public_path__ + "static/img/instant5.9d4e007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant5.png
// module id = wjXu
// module chunks = 1